import { useCallback, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useFetch } from '../common/useFetch';
import { useEmitMessage } from '../common/useEmitMessage';

/**
 * サブスクの解約を担う
 */
export const useSubscriptionCancel = (
  contractId: string | undefined,
  token: string
) => {

  const history = useHistory();
  const emitMessage = useEmitMessage();

  const success = () => {
    history.push('/cancel/complete');
    emitMessage('app-complete');
  };
  const failed = () => emitMessage('app-error', 'keep');

  const [cancelSubscriptionState, callUpdateSubscription] 
    = useFetch('updateSubscription', token, success, failed);

  // 通信開始時メッセージ出力
  useEffect(() => {
    if (cancelSubscriptionState.loading === true)
      emitMessage('app-canceling-contract', 'keep');
  }, [cancelSubscriptionState]);

  const cancelSubscription = useCallback((selected?: string, extraField?: string) => {
    if (!contractId) return;

    const param: UpdateSubscriptionParam = {
      subscriptionId: contractId,
      status: 'cancelled'
    };

    if (selected !== undefined || extraField !== undefined) {
      param.survey = { selected: selected || '', extraField: extraField || '' };
    }

    callUpdateSubscription(param);
    
  }, [contractId]);

  return [
    cancelSubscriptionState.loading,
    cancelSubscription
  ]as [ boolean, (selected?: string, extraField?: string) => void ];
};

// types

export type UpdateSubscriptionParam = {
  subscriptionId: string,
  status: 'cancelled',
  survey?: Survey
}

export type Survey = {
  selected: string
  extraField: string
}